import { setToken, removeToken } from '@/util/auth'
import { setStore, getStore } from '@/util/store'
import { validatenull } from '@/util/validate'
import { encryption } from '@/util/util'
import { loginByUsername, getTableData, getUserInfo } from '@/api/user'
import { refeshToken, logout } from '@/api/login/login'
import { getUserPermissionMenus, getUserPermission} from '@/api/salesCloud/menu'
import { findUserInfo } from '@/api/salesCloud/stuff'
const user = {
    state: {
        userInfo: {},
        permission: {},
        roles: [],
        menu: [],
        menuAll: [],
        systems: [],
        token: getStore({ name: 'token' }) || '',
    },
    actions: {
        //根据用户名登录
        LoginByUsername({ commit }, userInfo) {
            const user = encryption({
                data: userInfo,
                type: 'Aes',
                key: 'avue',
                param: ['useranme', 'password']
            });
            return new Promise((resolve) => {
                loginByUsername(user.username, user.password, userInfo.code, userInfo.redomStr).then(res => {
                    const data = res.data;
                    commit('SET_TOKEN', data);
                    commit('DEL_ALL_TAG');
                    commit('CLEAR_LOCK');
                    setToken(data);
                    resolve();
                })
            })
        },
        //根据手机号登录
        LoginByPhone({ commit }, userInfo) {
            return new Promise((resolve) => {
                loginByUsername(userInfo.phone, userInfo.code).then(res => {
                    const data = res.data;
                    commit('SET_TOKEN', data);
                    commit('DEL_ALL_TAG');
                    commit('CLEAR_LOCK');
                    setToken(data);
                    resolve();
                })
            })
        },
        GetTableData(params, page) {
            return new Promise((resolve) => {
                getTableData(page).then(res => {
                    const data = res.data;
                    resolve(data);
                })
            })
        },
        GetUserInfo({ commit }) {
            return new Promise((resolve) => {
                findUserInfo().then((res) => {
                    const data = JSON.parse(res.data);
                    commit('SET_USERIFNO', data);
                    // commit('SET_ROLES', data.roles);
                    // commit('SET_PERMISSION', data.permission)
                    resolve(data);
                })
                getUserInfo().then((res) => {
                    const data = res.data;
                    // commit('SET_USERIFNO', data);
                    commit('SET_ROLES', data.roles);
                    // commit('SET_PERMISSION', data.permission)
                    resolve(data);
                })
                getUserPermission().then((res) => {
                    const data = JSON.parse(res.data);
                    // commit('SET_USERIFNO', data);
                    // commit('SET_ROLES', data.roles);
                    commit('SET_PERMISSION', data)
                    resolve(data);
                })
            })
        },
        //刷新token
        RefeshToken({ commit }) {
            refeshToken().then(res => {
                commit('SET_TOKEN', res.data);
                setToken();
            })
        },
        // 登出
        LogOut({ commit }) {
            return new Promise(resolve => {
                logout().then(() => {
                    commit('SET_TOKEN', '')
                    commit('SET_ROLES', [])
                    commit('DEL_ALL_TAG');
                    commit('CLEAR_LOCK');
                    removeToken()
                    resolve()
                })
            })
        },
        //注销session
        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                commit('SET_ROLES', [])
                commit('DEL_ALL_TAG');
                commit('CLEAR_LOCK');
                removeToken()
                resolve()
            })
        },
        //获取系统菜单
        GetMenu({ commit }) {
            return new Promise(resolve => {
                getUserPermissionMenus().then((res) => {
                    const data = JSON.parse(res.data);
                    commit('SET_MENU', data);
                    resolve(data);
                })
            })
        }
        // //获取系统
        // GetSystems({ commit }) {
        //     return new Promise(resolve => {
        //         getUserSystems().then((res) => {
        //             const data = JSON.parse(res.data);
        //             if(data.length > 0){
        //                 commit('SET_SELECT_INDEX', data[0].id);
        //             }
        //             commit('SET_SYSTEMS', data);
        //             resolve(data);
        //         })
        //     })
        // },
        // //获取全部菜单
        // GetMenuAll({ commit }) {
        //     return new Promise(resolve => {
        //         getUserMenus().then((res) => {
        //             const data = JSON.parse(res.data);
        //             commit('SET_MENU_ALL', data);
        //             resolve(data);
        //         })
        //     })
        // },

    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
            setStore({ name: 'token', content: state.token, type: 'session' })
        },
        SET_USERIFNO: (state, userInfo) => {
            state.userInfo = userInfo;
        },
        SET_MENU: (state, menu) => {
            const list = menu.filter(ele => {
                if (validatenull(ele.meta)) return true;
                if (validatenull(ele.meta.roles)) return true;
                if (ele.meta.roles.indexOf(state.roles[0]) != -1) {
                    return true;
                } else {
                    return false;
                }
            });
            state.menu = list;
        },
        SET_MENU_ALL: (state, menuAll) => {
            state.menuAll = menuAll;
        },
        SET_ROLES: (state, roles) => {
            state.roles = roles;
        },
        // SET_SYSTEMS: (state, systems) => {
        //     state.systems = systems;
        // },
        SET_PERMISSION: (state, permission) => {
            state.permission = {};
            permission.forEach(ele => {
                state.permission[ele] = true;
            });
        }
        // SET_SELECT_INDEX: (state, index) => {
        //   state.selectIndex = index;
        // }
    }

}
export default user